import VehiclesError from './VehiclesError.js'

export default class GetModelInfoVehiclesError extends VehiclesError {}
